var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"task-audio-btn",attrs:{"type":"button"},on:{"click":function($event){return _vm.$store.dispatch('taskaudio/toggle')}}},[_c('i',{staticClass:"mdi",class:_vm.playing ? 'mdi-volume-off' : 'mdi-volume-high'})])}
var staticRenderFns = []

export { render, staticRenderFns }